import { Flex, List } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import UserDidItem from "./Did.card";
import Loader from "../../generic/Loader";
import { SmsDid } from "../../../interfaces/Did.type";

const spinStyle: React.CSSProperties = {
    width: "100%",
    height: "100%"
};

/**
 * UserDidsList component - displays a list of user DIDs
 *
 * @param {RootState} state - Redux state
 * @returns {JSX.Element} - Rendered UserDidsList component
 */
const UserDidsList = ({
    searchInput,
    setIsNewConversation,
    showCounter,
    bulk,
    isLoading
}: {
    searchInput: string;
    setIsNewConversation?: Function;
    showCounter: boolean;
    bulk?: boolean;
    isLoading?: boolean;
}): JSX.Element => {
    const { data, selectedDid } = useSelector((state: RootState) => state.smsDids);

    const filteredData = !searchInput ? data : data?.filter((userDid: SmsDid) => {
        return userDid.did.includes(searchInput) ||
            userDid.label?.toLowerCase().includes(searchInput.toLowerCase());
    });

    if (isLoading) {
        return (
            <Flex style={spinStyle} justify="center" align="center">
                <Loader />
            </Flex>
        );
    }
    return (
        <List
            itemLayout="horizontal"
            style={{
                padding: "4px",
                height: "calc(100% - 70px)",
                overflowX: "auto"
            }}
            dataSource={
                bulk
                    ? filteredData.filter(did => did.allow_bulk == true)
                    : filteredData
            }
            renderItem={(smsDid: SmsDid) => (
                <UserDidItem
                    showCounter={showCounter}
                    assigned={smsDid.assigned}
                    userDid={smsDid}
                    isSelected={smsDid.did === selectedDid}
                    setIsNewConversation={setIsNewConversation}
                />
            )}
        />
    );
};

export default UserDidsList;
